<template>
  <Grid :gtc="isSystem ? '1fr' : '1fr auto'" class="full-width cost-center bg-white-1 q-pa-md shadow3 border-radius-sm">
    <div class="text-body-3 text-secondary-1 text-ellipsis-2">{{ name }}</div>
    <DotsIcon v-if="!isSystem" :popup-items="popupItems" @popup-item="$emit($event.name)" />
  </Grid>
</template>

<script>
import DotsIcon from '@/ui/icons/DotsIcon'

export default {
  components: {
    DotsIcon
  },

  props: {
    name: {
      type: String,
      required: true
    },

    isSystem: Boolean
  },

  computed: {
    popupItems() {
      return [
        { name: 'edit', label: 'Edit' },
        { name: 'delete', label: 'Delete', textColorClass: 'text-danger-1' }
      ]
    }
  }
}
</script>
